import { useEffect, useState } from 'react';
import { documentService } from '../utils/window.utils';

const useStickyWrapper = (): HTMLElement | null => {
  const [stickyWrapperEle, setStickyWrapperEle] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setStickyWrapperEle(documentService().getElementById('sticky-top-wrapper'));
  }, []);

  return stickyWrapperEle;
};

export default useStickyWrapper;
